import React, { forwardRef, useState } from 'react'
import { useReadNotificationMutation, useUnreadNotificationQuery } from '../../../core/services/react-query/useNotificationsQuery'
import { DropBody } from '../../../styles/layout-styles/HeaderStyles';
import BellIcon from '../../../components/icons/BellIcon';
import { Text, useWindowSize } from '../../../modules/Dashboard';
import { Link } from 'react-router-dom';
import NotificationCard from './NotificationCard';
import { ScaleLoader } from 'react-spinners';
import { MOBILE_SIZE } from '../../../core/constants/common';
import ModalLayout from '../../../components/layouts/ModalLayout';
import MobileModal from '../../../components/layouts/MobileModal';
import NotificationDetails from './NotificationDetails';

const NotificationDropdown = forwardRef(({ onClose, isOpen }, ref) => {
    const { width } = useWindowSize()
    const { data: unreadNotifications, isLoading } = useUnreadNotificationQuery();
    const { mutate: readNotif } = useReadNotificationMutation()
    const [modal, setModal] = useState({ show: false, data: null })
    const onCloseModal = () => setModal({ show: false, data: null })

    const onOpenModal = (notif) => {
        console.log(notif);

        setModal({
            show: true, data: notif
        })
        if (!notif.readAt) {
            readNotif(notif._id)
        }
    }

    return (
        <>

            {
                width >= MOBILE_SIZE ?
                    <DropBody minWidth='400px' style={{ padding: '16px', borderRadius: "16px", }}>
                        <div className="h-[2px] w-[90%] absolute left-1/2 -translate-x-1/2 top-0 bg-gradient-to-r from-primaryOrange/0 via-primaryOrange to-primaryOrange/0" />

                        <div className="h-[2px] w-[90%] absolute left-1/2 -translate-x-1/2 bottom-0 bg-gradient-to-r from-primaryOrange/0 via-primaryOrange to-primaryOrange/0" />
                        <RenderNotifications unreadNotifications={unreadNotifications} isLoading={isLoading} onOpenModal={onOpenModal} />
                    </DropBody> :
                    <MobileModal isOpen={isOpen} onClose={onClose}>
                        <div ref={ref}>
                            <RenderNotifications unreadNotifications={unreadNotifications} isLoading={isLoading} onOpenModal={onOpenModal} />
                        </div>
                    </MobileModal>
            }

            {
                width >= MOBILE_SIZE ?
                    <ModalLayout open={modal?.show} onClose={onCloseModal} width={"600px"}>
                        <NotificationDetails notification={modal?.data} onClose={onCloseModal} />
                    </ModalLayout> :
                    <MobileModal isOpen={modal?.show} onClose={onCloseModal} >
                        <NotificationDetails notification={modal?.data} onClose={onCloseModal} />
                    </MobileModal>
            }
        </>
    )
})

export default NotificationDropdown


const RenderNotifications = ({ unreadNotifications, isLoading, onOpenModal }) => {
    return (
        <>
            {
                isLoading ?
                    <div className='max-w-screen-xl h-[calc(100vh-12rem)] flex items-center justify-center mx-auto backdrop-blur-2xl z-[999]'>
                        <ScaleLoader color='#9F64DF' />
                    </div> :
                    <div className='space-y-2 w-full text-center'>
                        <div className='flex justify-start items-center gap-2 mb-3'>
                            <BellIcon />
                            <Text tid={"notifications"} />
                            <div className='rtl:mr-auto ltr:ml-auto' />
                            <Link to={"/notifications"}>
                                <Text tid={'all'} className='text-mainColor underline' />
                            </Link>
                        </div>
                        {
                            unreadNotifications?.data?.length > 0 ?
                                <>
                                    {unreadNotifications.data.map((notif) => {
                                        return (
                                            <NotificationCard mini key={notif?._id} notif={notif} onClick={onOpenModal} />
                                        )
                                    })}
                                </> :
                                <div className='my-5'>
                                    <Text tid={"no-unread-notifications"} className='text-mainColor' />
                                </div>
                        }
                    </div>
            }
        </>
    )
}